import { useContext, useRef, useState } from 'react';
import { SortableElement, sortableHandle} from 'react-sortable-hoc';
import { stateContext } from './ctx';
import {deepCopy, hueAlterColor} from './functions'
import ColorIcon from './ColorIcon'
import { icons } from './icons';
import EditColor from './EditColor';

const DragHandle = sortableHandle(()=><div className='w-[6px] h-[18px] grid grid-cols-2 gap-[2px] cursor-row-resize'>
<div className='bg-slate-300 dark:bg-slate-500 w-[2px] h-[2px]'></div>
<div className='bg-slate-300 dark:bg-slate-500 w-[2px] h-[2px]'></div>
<div className='bg-slate-300 dark:bg-slate-500 w-[2px] h-[2px]'></div>
<div className='bg-slate-300 dark:bg-slate-500 w-[2px] h-[2px]'></div>
<div className='bg-slate-300 dark:bg-slate-500 w-[2px] h-[2px]'></div>
<div className='bg-slate-300 dark:bg-slate-500 w-[2px] h-[2px]'></div>
<div className='bg-slate-300 dark:bg-slate-500 w-[2px] h-[2px]'></div>
<div className='bg-slate-300 dark:bg-slate-500 w-[2px] h-[2px]'></div>
<div className='bg-slate-300 dark:bg-slate-500 w-[2px] h-[2px]'></div>
<div className='bg-slate-300 dark:bg-slate-500 w-[2px] h-[2px]'></div>
</div>)


const Leaf = SortableElement(({value,idx}) => {
    const [open,setOpen] = useState(false)
    const {hue,schema,setSchema} = useContext(stateContext)
  
    const cnt = open ? <EditColor startColor={hueAlterColor(value.c,hue)} idx={idx} /> : []

    const deletePoint = () => {
        const newSchema = deepCopy(schema)
        if (newSchema.length > 2){
            newSchema.splice(idx,1)
            setSchema(newSchema)
        }
    }
    const leafRef = useRef(null)


        return <div ref={leafRef} className='overflow-hidden shadow-sm group flex-col flex justify-center rounded-lg bg-white font-semibold dark:bg-slate-700'>
            <div className='flex gap-2 p-2 items-center flex-1'>
            <DragHandle />
            <ColorIcon value={hueAlterColor(value.c,hue)} className='rounded-md w-8 h-8 cursor-pointer' onClick={()=>setOpen(!open)}/>
            <span>{hueAlterColor(value.c,hue)}</span>
            <div className='btn ml-auto group-hover:opacity-100 opacity-0' onClick={deletePoint}>{icons.close}</div>
            <div className='btn' onClick={()=>setOpen(!open)}>{icons.arrowDown}</div>
        </div>
        {cnt}
      </div>

   /* 
        return <div ref={leafRef}>
            <ColorIcon value={hueAlterColor(value.c,hue)} className={'w-12 h-8 rounded-full'} onClick={()=>setOpenEditColor({idx:idx.toString(),ref:leafRef.current})}>
                <div className='flex-1 cursor-pointer h-full'></div>
                <DragHandle />
            </ColorIcon>
            
        </div>
    
    return <div ref={leafRef} className='flex flex-col h-12 relative'>
          <ColorIcon value={hueAlterColor(value.c,hue)} className={'flex-1 rounded-tr-md rounded-tl-md cursor-pointer hover:opacity-70 '} onClick={()=>setOpenEditColor({idx:idx.toString(),ref:leafRef.current})} />
          <div className='flex-1 flex justify-center rounded-br-md bg-white border border-t-0 dark:border-0 dark:bg-slate-800 rounded-bl-md cursor-row-resize'>
              <DragHandle />
          </div>
        
    </div> */

});

export default Leaf;